const expiredOrderCard = () =>
  import("@/components/OrderProcessPage/Withdrawal/ExpiredOrderCard/index");
const canceledOrderCard = () =>
  import("@/components/OrderProcessPage/Withdrawal/CanceledOrderCard/index");
import { OperationService } from "@/services";
import * as types from "@/store/types";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "withdrawal",
  components: { expiredOrderCard, canceledOrderCard },
  props: [],
  data() {
    return {
      modalStatus: "",
      dialog: false,
      resetCountDown: false
    };
  },
  computed: {
    ...mapGetters({
      isOrderExpired: types.operations.getters.GET_ORDER_EXPIRATION_STATUS,
      getProcessingOrder: types.operations.getters.GET_PROCESSING_ORDER,
      getCancelOrderStep: types.operations.getters.GET_CANCEL_ORDER_STEP
    }),
    orderTransactionId() {
      return this.$route.params.id;
    },
    orderProcessData() {
      return this.getProcessingOrder;
    },
    getCancelOrderStepData() {
      if (this.getCancelOrderStep) {
        return this.getCancelOrderStep;
      }
    }
  },
  watch: {
    isOrderExpired: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.onExpiredOrder();
        }
      }
    }
  },
  mounted() {
    // this.getOrderData();
    // this.getUserData();
  },
  methods: {
    ...mapActions({
      setUserInfo: types.userInfo.actions.ACTION_USER_INFO,
      setOrderExpiration:
        types.operations.actions.ACTION_ORDER_EXPIRATION_STATUS,
      setCountDownStatus: types.operations.actions.ACTION_COUNTDOWN_STATUS
    }),
    onExpiredOrder() {
      this.modalStatus = "expiredOrder";
      this.dialog = !this.dialog;
    },
    cancelOrder() {
      this.modalStatus = "canceledOrder";
      this.dialog = true;
    },
    onCancelOrder(event) {
      let data = {
        ref_no: this.orderTransactionId
      };
      OperationService.cancelOrder(data).then(() => {
        if (event !== undefined) {
          this.dialog = event;
          this.$router.push(
            `/operations/withdrawal?from=${this.orderProcessData.from_currency_iso}`
          );
        }
      });
    },
    // getUserData() {
    //   AuthService.userInfo().then(response => {
    //     this.setUserInfo(response.data.data);
    //     this.phoneNumber = response.data.data.mobile;
    //   });
    // },
    onConfirmReorder(event) {
      if (this.$route.path.includes("crypto")) {
        this.orderCryptoWithdraw(event);
      } else {
        this.orderRialWithdraw(event);
      }
      this.setCountDownStatus(true);
      this.setOrderExpiration(false);
    },
    orderRialWithdraw(dialogEvent) {
      let data = {
        amount: this.orderProcessData.from_amount,
        to_address: this.orderProcessData.to_address,
        to_address_extra: this.orderProcessData.to_address_extra
      };
      OperationService.withdrawIRR(data).then(response => {
        this.orderId = response.data.data.ref_no;
        this.$router.replace(
          `/submit-order/${this.orderId}/withdrawal/rial`,
          () => {}
        );
        this.dialog = dialogEvent;
      });
    },
    orderCryptoWithdraw(dialogEvent) {
      let data = {
        amount: this.orderProcessData.from_amount,
        network_id: this.orderProcessData.network.id,
        currency_id: this.orderProcessData.from_currency.id,
        to_address: this.orderProcessData.to_address,
        to_address_extra: this.orderProcessData.to_address_extra
      };
      OperationService.withdrawCrypto(data).then(response => {
        this.orderId = response.data.data.ref_no;
        this.$router.replace(
          `/submit-order/${this.orderId}/withdrawal/crypto`,
          () => {}
        );
        this.dialog = dialogEvent;
      });
    }
  }
};
